/** @jsx jsx */
import React from 'react';
import { jsx } from '@compiled/react';
import { AppSkeletonImage } from '@jira/platform__skeleton-image-container/src/ui/AppSkeletonImage.tsx';

import imgSVG from './assets/field-schemes-app-skeleton.tpl.svg';

export const FieldSchemesSkeleton = (): JSX.Element => <AppSkeletonImage src={imgSVG} />;
